import { useCallback, useEffect } from 'react'
import { useSelector } from '@/libs/state'
import { resolveDeptMemberIds } from '../application/resolve-dept-member-ids'
import { deptMemberIds$ } from '../store'
import { members as membersPort, departments as departmentsPort } from '../wiring'

const useDeptMemberIds = (leaderId: string | null) => {
	const memberIds = useSelector(deptMemberIds$)

	const reload = useCallback(async () => {
		if (!leaderId) {
			deptMemberIds$.set([])
			return
		}
		const ids = await resolveDeptMemberIds(membersPort, departmentsPort, leaderId)
		deptMemberIds$.set(ids)
	}, [leaderId])

	useEffect(() => {
		reload()
	}, [reload])

	return { memberIds }
}

export { useDeptMemberIds }
